var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _path10, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlpha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.6C19 20.2826 14.625 22.5 12 22.5C9.375 22.5 5 20.2826 5 13.6C5 6.91735 8.13401 2.5 12 2.5C15.866 2.5 19 6.91735 19 13.6Z",
    fill: "#EBD2B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6552 6.81821H6.34483C7.61811 4.09506 9.6769 2.5 12 2.5C14.3231 2.5 16.3819 4.09506 17.6552 6.81821Z",
    fill: "#2685A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98207 7.68142C7.16116 6.92587 8.74955 6.1644 10.4352 5.55777C11.6827 5.10884 12.9348 4.76257 14.0415 4.57268C14.8609 4.43207 15.5498 4.38634 16.0796 4.42323C16.5028 4.2787 14.0913 2.40527 13.3085 2.67399C12.1713 2.89618 10.9504 3.24681 9.75802 3.67592C9.15044 3.89457 8.53958 4.1375 7.94271 4.39925C7.15082 5.24558 6.48139 6.35387 5.98207 7.68142Z",
    fill: "#3898B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1728 5.90268C16.3204 5.29085 15.3876 4.67525 14.4615 4.10019C13.5395 3.52768 12.6019 2.98161 11.7294 2.50726C11.1781 2.16251 8.84289 3.05439 9.09852 3.40851C10.2608 3.95481 11.8327 4.82206 13.4064 5.79926C15.3655 7.01578 17.2236 8.33885 18.2477 9.34531L18.469 9.12017C18.1561 7.89878 17.715 6.81817 17.1728 5.90268Z",
    fill: "#3898B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9525 12.1971C18.5307 11.1921 17.7171 10.2293 16.6102 9.34988C15.3212 8.32572 13.7095 7.47551 12.0904 6.85585C10.4688 6.23527 8.89317 5.86622 7.69574 5.77063C7.40172 5.74716 7.14281 5.74123 6.92001 5.74915C6.51953 5.65625 7.92815 3.76916 8.51794 3.84886C9.81208 4.02373 11.3117 4.41639 12.8052 4.98797C14.564 5.66106 16.3675 6.60258 17.8544 7.78398C17.9501 7.86005 18.1479 8.01325 18.2415 8.09183C18.6814 8.4133 19.5498 12.255 18.9525 12.1971Z",
    fill: "#4DC3E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.675 6.84931C17.3699 6.75667 16.1593 6.70814 15.5672 6.70598C14.3908 6.70168 12.8536 6.93298 11.2936 7.4117C9.73317 7.89056 8.21123 8.59827 7.03534 9.50591C6.07755 10.2452 5.19592 11.6567 5.06288 11.9905C4.53094 11.9426 5.04551 8.03431 5.89819 7.52508C7.40037 6.62794 9.03389 6.0131 10.7068 5.4997C12.4248 4.9725 14.1637 4.70084 15.5745 4.70599C15.8421 4.70697 16.2338 4.71056 16.458 4.75842C16.8117 4.83392 17.9345 6.9281 17.675 6.84931Z",
    fill: "#4DC2E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4072 4.10559L13.9072 6.10559L12.4072 8.10559L10.9072 6.10559L12.4072 4.10559Z",
    fill: "#FFB800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4072 4.87572L13.3437 6.12428L12.4072 7.33547L11.4707 6.12428L12.4072 4.87572Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3437 6.12428L12.4072 6.61804L11.4707 6.12428",
    stroke: "#FFB800",
    strokeWidth: 0.25
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.1859,
    cy: 11.3768,
    rx: 0.4129,
    ry: 0.940074,
    transform: "rotate(60 10.1859 11.3768)",
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.4129,
    ry: 0.940074,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 13.8141 11.3768)",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1587 19.1992C13.3782 18.8709 13.5103 18.4478 13.5103 17.9861C13.5103 16.9417 12.8341 16.5314 12 16.5314C11.1659 16.5314 10.4897 16.9417 10.4897 17.9861C10.4897 18.4478 10.6218 18.8709 10.8413 19.1992C11.0452 18.6539 11.4874 18.2762 12 18.2762C12.5126 18.2762 12.9548 18.6539 13.1587 19.1992Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_455_0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.0109,
    cy: 13.8715,
    rx: 1.49935,
    ry: 1.22598,
    fill: "#EBD2B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_455_0",
    x: 10.2616,
    y: 12.6455,
    width: 3.4987,
    height: 3.20197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_455_0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_455_0",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpha);
export default __webpack_public_path__ + "static/media/alpha.d892294a8cb34c5a835b64f2d102e933.svg";
export { ForwardRef as ReactComponent };